import React, { useEffect, useMemo, useState } from "react";
import classnames from "classnames";
import Styles from "./styles.module.scss";
import Headline5 from "../../components/headings/Headline5";
import FromHead from "../../components/headings/FromHead";
import CommentBox from "../../components/commentBox";
import Button from "../../components/button";
import * as CONSTANTS from "../../utils/CONSTANTS";
import { useForm } from "react-hook-form";
import { DropDownInput } from "../../wrappers/selectInput";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { addInsightComments, getComments, getPositionDetails, getProviderResources, getRecruiterResources } from "./services";
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  convertToRaw,
  convertFromRaw,
  ContentState,
} from "draft-js";
import { convertToHTML } from "draft-convert";
import htmlToDraft from "html-to-draftjs";
import {useLocation} from 'react-router-dom'
import { checkCandidateStatus, checkSourcedBy, getMilliSecUTC } from "../../utils/EllowUtils";
import mixpanelData from "../../utils/mixpanel";


export type EllowInsightsForm = {
  sourcedByType: any;
  sourcedByName: any;
  ellowScreeningCertifications: any;
  ellowStatus: any;
  recruiterDetails: any;
  rejectComment: any;
  candidateWorkType: string;
};

interface Props {
  ClickHandler?: any;
  allocatedTo?: any;
  candidateId?: any;
  profileMetadata?: any;
  candidateStatus: number;
  allocationDefault?: any;
  behalfof?: any;
  sourcedBy?: string;
  rejectReason?: any;
  candidateLoginId: any;
  createdBy?: string;
  employeeId?: string;
  submittedBy?: string;
}


const EllowInsights: React.FC<Props> = ({
  ClickHandler,
  allocatedTo,
  candidateId,
  candidateLoginId,
  profileMetadata,
  candidateStatus,
  allocationDefault,
  behalfof,
  sourcedBy,
  rejectReason,
  createdBy,
  employeeId,
  submittedBy
}) => {
  const location: any = useLocation()

  // const  candidateLoginId : any =  localStorage.getItem('candidateLoginId') || location.state.candidateLoginId || ''
  const email = localStorage.getItem('Email')
  const [allocatedToData, setAllocatedToData] = useState<any>();
  const [editorShow, setEditorShow] = useState<boolean>(false);
  const [positionDetails, setPositionDetails] = useState<any>()
  const [sourced, setSourced] = useState<string>();
  const [behalf, setBehalf] = useState<string>();
  const [candidate_status , setCandidate_status] = useState<number>(0)
  const [disable, setDisable] = useState<boolean>(true);
  const [disableSourceType , setDisableSourceType ] = useState<boolean>(false)
  const [dropDownData, setDropDownData] = useState([]);
  const [comments, setComments] = useState<any>()
  const [editorState, setEditorState] = useState<any>(
    EditorState.createEmpty()
  );
  const validationSchema = Yup.object({});

  const formOptions = {
    resolver: yupResolver(validationSchema),
    // defaultValues: useMemo(() => {
    //   return defaultValues;
    // }, [defaultValues]),
  };

  const { register, handleSubmit, control, reset, setValue, formState, watch, setError, setFocus } =
    useForm<EllowInsightsForm>(formOptions);

  useEffect(() => {
    
    if(candidateStatus){
      setCandidate_status(candidateStatus)
    }
    getRecruiterList();     
      getPositionDetails(candidateLoginId).then((response: any) => {
        setPositionDetails(response.data)
      })
    if (candidateStatus) {
     setValue('ellowStatus',checkCandidateStatus(candidateStatus))
    }

    if (sourcedBy === 'CS-RECRUITER' || sourcedBy === 'PROVIDER' || sourcedBy === 'FREELANCER') {
      setDisableSourceType(true)
      setDisable(true)
    }
    if(candidateStatus > 2){
      if(email !== 'jjoseph@ellow.io'){
        setDisable(true)
        setDisableSourceType(true)
      }
    }
    if (profileMetadata && profileMetadata.ellowScreeningCertifications) {
      setValue('ellowScreeningCertifications',profileMetadata.ellowScreeningCertifications)
    }
    if (profileMetadata && profileMetadata.workType) {
      setValue('candidateWorkType', checkWorkType(profileMetadata.workType))
    }

    if (allocationDefault) {
      setValue('recruiterDetails',allocationDefault)
    }
    if (behalfof) {
      setValue('sourcedByName', behalfof)      
    }
    if (sourcedBy) {
      setValue('sourcedByType',checkSourcedBy(sourcedBy))
    }

    if (rejectReason)
    {
      if (rejectReason.includes('{"blocks')) {
        let oldblockconverteddata = convertFromRaw(
          JSON.parse(rejectReason)
        );
        let oldblockdataconvertedhtml = convertToHTML(oldblockconverteddata);

        rejectReason = JSON.stringify(
          oldblockdataconvertedhtml
        );
      }
      setValue('rejectComment', rejectReason)
      setEditorShow(true)
      const contentState = editorState.getCurrentContent();
      
    if (JSON.stringify(convertToRaw(contentState)) !== rejectReason) {
      try {
        setEditorState(EditorState.createWithContent(convertFromRaw(JSON.parse(rejectReason)))); 
      }
      catch (e) {
       // setEditorState(EditorState.createWithContent(ContentState.createFromText(rejectReason)));
       let rejectReasondata =rejectReason;
       let convertdata = rejectReasondata.includes("<p>");
       let olconvertdata = rejectReasondata.includes("<ol");
       let ulconvertdata = rejectReasondata.includes("<ul>");
       if (convertdata || olconvertdata || ulconvertdata) {
         const blocksFromHTML = htmlToDraft(JSON.parse(rejectReasondata));
         const updateblockstate = ContentState.createFromBlockArray(
           blocksFromHTML.contentBlocks,
           blocksFromHTML.entityMap
         );
         setEditorState(EditorState.createWithContent(updateblockstate));
       } else {
         const blocksFromHTML = htmlToDraft(rejectReasondata);
         const updateblockstate = ContentState.createFromBlockArray(
           blocksFromHTML.contentBlocks,
           blocksFromHTML.entityMap
         );
         setEditorState(EditorState.createWithContent(updateblockstate));
       }

      }
      }
    }
    getAllComments()
  }, []);

  const checkWorkType = (data: any) => {
    switch (data){
      case '1':
        return 'Career Freelancers';
      case '2':
        return 'Full time employee';
      case '3':
        return 'Open for both'
      default:
        return ''
    }
  }

  useEffect(() => {
    if (watch().ellowStatus) {
      if (watch().ellowStatus.id === "6" || watch().ellowStatus.id === "7") {
        setEditorShow(true);
      } else {
        setEditorShow(false);
      }
    }
  }, [watch().ellowStatus]);

  useEffect(() => {
    
    if (submittedBy === 'RECRUITER') {
      sourcedByType(watch());
      if (!behalfof || sourcedBy && watch().sourcedByType !== checkSourcedBy(sourcedBy)) {
        setValue("sourcedByName", null);
      }
    }
  }, [watch().sourcedByType]);

  useEffect(() => {
    sourcedByName(watch());
  }, [watch().sourcedByName]);

  const sourcedByType = (data: any) => {
    if (data.sourcedByType !== undefined) {
      setSourced(data.sourcedByType);
      if (data.sourcedByType === "Provider") {
        getProviderResources().then((response: any) => {
          if (response.status === 1) {       
            setDropDownData(response.data)
            if(candidateStatus < 3 ){
              setDisable(false)
            }
            if(!candidateStatus){
              setDisable(false)
            }
          }
        });
      }
      if (data.sourcedByType === "Recruiter" || data.sourcedByType === "Proactive") {
        getRecruiterList()
        if(candidateStatus < 3){
          setDisable(false)
        }
        if(!candidateStatus){
          setDisable(false)
        }
      }
    }
  };

  const getAllComments = () => {
    getComments(candidateLoginId).then((response: any) => {
      setComments(response.data)
    })
  }

  const sourcedByName = (data: any) => {
    if (data.sourcedByName !== undefined) {
      setBehalf(data.sourcedByName);
    }
  };

  const getRecruiterList = () => {
    getRecruiterResources().then((response: any) => {
      if (response.status === 1) {
        setAllocatedToData(response.data);
        setDropDownData(response.data);
      }
    });
  };

  const onSubmit = (data: any) => {  
    
    if ((data.ellowStatus === 5 || data.ellowStatus === 6 ) && !data.rejected) {
      setError('ellowStatus', { type: 'required', message: 'Please provide the reason' })
      ClickHandler(data)
    }
    else {
      ClickHandler(data)
    }
  };

  const certifications = (data: any) => {
    setValue('ellowScreeningCertifications',data.ellowScreeningCertifications)
  };

  const onEditorStateChange = (state: any) => {
    setEditorState(state);
    const contentState = state.getCurrentContent();
    let currentContentAsHTML = convertToHTML(contentState);
    setValue("rejectComment", JSON.stringify(currentContentAsHTML));
  };

  const selectClassName = (data: any) => {
    switch (data) {
      case 'Resource Accepted Offer':
        return "green"
      case 'Submitted to Hirer':
        return "cold"
      case 'Resource Rejected Offer':
        return 'hot'
     }
  }

  const addComment = (data: any) => {
    let body = {
      "commentJson":{
          "comment":data,
          "recruiterName":localStorage.getItem('Name'),
          "date":getMilliSecUTC(new Date())
      },
      "loginId":candidateLoginId
  }
    addInsightComments(body).then((response) => {
      if (response && response.status === 1) {
        mixpanelData('New TG - Comments added', {
          "distinct_id": localStorage.getItem('Email'),
          "Recruiter email": localStorage.getItem('Email'),
          "Candidate email": response && response.data[0].profile_metadata.email,
          "Candidate name": response && response.data[0].profile_metadata.firstName + " " + response.data[0].profile_metadata.lastName,
          "Comment": data,
          "Candidate loginid": candidateLoginId
        })
        getAllComments()
     }
   })
 }

  return (
    <>
      <div
        className={classnames("panelbarwrapperMyprofile", Styles.tabPadding)}
      >
        <div className={Styles.ellowInsightWrap}>
          <div className={Styles.ellowInsight}>
            <Headline5>Ellow Insight</Headline5>
            <form>
            <section className={Styles.preferencesSection}>
              {employeeId !== null &&
                <FromHead>Employee id: <span className="subText">{employeeId}</span></FromHead>
              }
              <FromHead>ellow status</FromHead>
              <div className="half-form-wrap">
                  <div className="form-group">
                    <label className="lablel">Status</label>
                    <DropDownInput<EllowInsightsForm>
                      data={CONSTANTS.candidateStatus}
                      name="ellowStatus"
                      control={control}
                      dataItemKey="id"
                      textField="name"
                      register={register}
                      disabled={ createdBy === localStorage.getItem('loginId') && candidateStatus < 3 }
                      errors={formState.errors}
                      defaultValue={candidateStatus && candidateStatus > 4 && checkCandidateStatus(candidateStatus)}
                    />
                  </div>
                </div>
                {editorShow && (
                  <div className="form-group">
                    <label className="lablel">
                      Reason for blacklist/Rejected
                    </label>
                    <Editor
                      editorState={editorState}
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="wrapperClassName"
                      editorClassName="editorClassName"
                      onEditorStateChange={onEditorStateChange}

                    />
                  </div>
                )}
              </section>
            <section className={Styles.preferencesSection}>
                <FromHead>Recruiter details</FromHead>
                <div className="half-form-wrap">
                  <div className="form-group">
                    <label className="lablel">Allocated To</label>
                    <DropDownInput<EllowInsightsForm>
                      data={allocatedToData}
                      name="recruiterDetails"
                      control={control}
                      dataItemKey="id"
                      textField="name"
                      register={register}
                      errors={formState.errors}
                      defaultValue={allocationDefault}
                    />
                  </div>
                </div>
              </section>

              <section className={Styles.preferencesSection}>
                <FromHead>Sourcing details</FromHead>
                <div className={Styles.sourcingWrap}>
                  <div className={classnames("form-group", Styles.sourceBy)}>
                    <label className="lablel">Source type</label>
                    <DropDownInput<EllowInsightsForm>
                      data={["Provider", "Recruiter", "Proactive", "CS-Recruiter"]}
                      name="sourcedByType"
                      control={control}
                      defaultValue={sourcedBy && checkSourcedBy(sourcedBy)}
                      register={register}
                      errors={formState.errors}
                      disabled={disableSourceType}
                    />
                  </div>
                  <div className={classnames("form-group", Styles.sourceName)}>
                    <label className="lablel">Source name</label>
                    <DropDownInput<EllowInsightsForm>
                      data={dropDownData}
                      name="sourcedByName"
                      control={control}
                      disabled={disable}
                      register={register}
                      errors={formState.errors}
                      dataItemKey={'id'}
                      textField={'name'}
                    />
                  </div>
                </div>
              </section>
            {/* <section className={Styles.preferencesSection}>
                
                <Certifications certificationValue={certifications} defaultValues={profileMetadata && profileMetadata.ellowScreeningCertifications } />
              </section>   */}
              <section className={Styles.preferencesSection}>
              { positionDetails && positionDetails.length > 0 && <FromHead>Position status</FromHead>}
                <div className="positionStatus">
                  <ul>
                    {positionDetails && positionDetails.length > 0 && positionDetails.map((item: any) => {
                      return (
                        <li className={selectClassName(item.current_stage)}>
                      {item.position_name} - {item.company}
                          <span>{item.current_stage}</span>
                      </li>
                      )
                      
                  }) }
                    {/* <li className="cold">
                      Developer - Google
                      <span>Submitted to hirer</span>
                    </li>
                    <li className="warm">
                      Developer - PWC
                      <span>Submitted to hirer</span>
                    </li> */}
                  </ul>
                </div>
              </section>
              <section>
              <FromHead>Candidate Work Type</FromHead>
                <div className="half-form-wrap">
                  <div className="form-group">
                    <DropDownInput<EllowInsightsForm>
                      data={CONSTANTS.candidateWorkType}
                      name="candidateWorkType"
                      control={control}
                      register={register}
                      errors={formState.errors}
                      disabled={true}
                      // defaultValue={'Open for both'}
                    />
                  </div>
                </div>
              </section>
              <div className="action-form">
                <Button onClick={handleSubmit(onSubmit)} variant="primary">
                  Save
                </Button>
              </div>
            </form>
          </div>
          <div className={Styles.commentArea}>
            <CommentBox data={comments} clickHandler={addComment} />
          </div>
        </div>
      </div>
    </>
  );
};
export default EllowInsights;
